import React, { useState, useEffect, useMemo } from 'react';
import { List, Tag, Pagination, Switch, Button, Modal } from 'antd';

type Props = {};

const filterObjectKeys = (obj: any) => {
    return Object.keys(obj).filter((key) => !key.startsWith('_'));
};

const levenMap: { [key: string]: string } = {
    TRACE: 'orange',
    DEBUG: 'volcano',
    INFO: 'red',
    WARN: 'magenta',
    ERROR: '#f50',
};

const renderText = (text:string, item:any, key:string, isPerk:boolean) => {
  if(text === 'level'){
      return <Tag color={levenMap[item[key]]}>{item[key]}</Tag>
  }else if(text === 'message' && isPerk){
      return item[key].length > 10 ? item[key].slice(0,10) + '...' : item[key]
  }else {
     return  item[key]
  }
}


export const Log = (props: Props) => {
    const [arr, setArr] = useState<any[]>([]);
    const [count, setCount] = useState<number>(1);
    const [checked, setChecked] = useState<boolean>(true); // 默认开关为 true
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [content, setContent] = useState<any>({});

    useEffect(() => {
        let reader: ReadableStreamDefaultReader<Uint8Array> | null = null;
        const fetchSSE = async (url: string, token: string) => {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'text/event-stream', // 指定接收 SSE
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // @ts-ignore
            reader = response.body?.getReader(); // 获取流读取器
            const decoder = new TextDecoder('utf-8');
            let buffer = '';

            while (reader) {
                const { done, value } = await reader.read();
                if (done) {
                    console.log('SSE connection closed.');
                    break;
                }

                // 将二进制流解码为文本
                buffer += decoder.decode(value, { stream: true });

                // 按行解析 `text/event-stream` 格式
                let lines = buffer.split('\n');
                buffer = lines.pop() || ''; // 保留未完成的行

                for (let line of lines) {
                    if (line.startsWith('data: ')) {
                        const eventData = line.substring(6).trim();

                        try {
                            // 尝试将字符串解析为 JSON
                            const parsedData = JSON.parse(eventData);

                            // 如果开关是开启状态，则更新数组
                            if (checked) {
                                setArr((prevArr) => {
                                    const newArr = [parsedData, ...prevArr];

                                    // 如果数组长度超过 100，删除末尾的元素
                                    if (newArr.length > 100) {
                                        newArr.pop(); // 删除最后一个元素
                                    }

                                    return newArr; // 返回新的数组
                                });
                            }
                        } catch (error) {
                            console.log('Received event data as string:', eventData);
                        }
                    }
                }
            }
        };

        if (checked) {
            // 只有在 checked 为 true 时启动 SSE 连接
            fetchSSE(
                '/api/v1/admin/log',
                localStorage.getItem('Authorization') || ''
            );
        }

        // 清理函数，取消读取流并关闭 SSE 连接
        return () => {
            if (reader) {
                reader.cancel(); // 停止读取 SSE 流
                console.log('SSE connection cancelled.');
            }
        };
    }, [checked]); // 将 checked 作为依赖

    // 使用 useMemo 缓存分页后的数组
    const paginatedArr = useMemo(
        () => arr.slice((count - 1) * 10, count * 10),
        [arr, count]
    );

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const showModal = (item:any) => {
        setContent(item)
        setIsModalOpen(true);
    };


    return (
        <div>
            <div style={{margin:'20px 0'}}>
              开启/关闭日志监控：  <Switch
                    defaultChecked
                    onChange={(checked: boolean) => {
                        setChecked(checked); // 使用 checked 作为更新值
                    }}
                />
            </div>
            <div className="site-card-wrapper">
                <List
                    size="large"
                    header={<div>日志</div>}
                    bordered
                    dataSource={paginatedArr}
                    renderItem={(item) => (
                        <List.Item onClick={()=>{showModal(item)}}>
                            <div>
                                {filterObjectKeys(item).map((key: string) => (
                                    <div key={key} style={{ margin: '2px', display: 'block' , textAlign:'left'}} >
                                        {key} :{' '}
                                        {renderText(key, item, key, true)}
                                    </div>
                                ))}
                            </div>
                        </List.Item>
                    )}
                />
            </div>
            <div style={{display:'flex', margin:'20px 0', justifyContent:'right'}}>
                <Pagination
                    current={count}
                    total={arr.length}
                    pageSize={10}
                    onChange={(page) => setCount(page)}
                />
            </div>

            <Modal title="Basic Modal" open={isModalOpen} onCancel={handleCancel} okText={''}>
                {filterObjectKeys(content).map((key: string) => (
                    <div key={key} style={{ margin: '8px', display: 'block' , textAlign:'left'}}>
                        {key} :{' '}
                        {renderText(key, content, key, false)}
                    </div>
                ))}
            </Modal>
        </div>
    );
};
